import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import './tuneup.scss';
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiCloudUploadOutline, mdiReload } from '@mdi/js';
import { Link, Navigate, useLocation, useNavigate, NavLink, BrowserRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import agent from '../../agent';
import { IMAGEUPLOAD, REPLACE_PARTS_DATA, IMAGEUPLOAD_UNLOAD } from '../../constants/actionTypes';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDropzone } from 'react-dropzone';
import { Helmet } from "react-helmet";
import Modal from 'react-modal';
import { mdiClose, mdiCalendar, mdiClockTimeTwoOutline, mdiLightbulbFluorescentTubeOutline } from '@mdi/js';
import durationIcon from '../TuneUp/duration.svg';
import { mdiCloseCircleOutline } from '@mdi/js';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import Footer from '../../components/Footer/Footer';
const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 8
};

const thumb = {
  display: 'flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  //width: '10%',
  width: 180,
  height: 100,
  padding: 4,
  boxSizing: 'border-box',
  justifyContent: 'space-between'
};

const thumbInner = {
  display: 'flex',
  // Width:'30%',
  //justifyContent:'space-between'
  //overflow: 'hidden'
};

const img = {
  //display: 'block',
  //width: 'auto',
  width: '100%',
  height: '100%',
  position: 'relative'
};



const mapStateToProps = state => ({ ...state });

const TuneUp = (props) => {
  // const [isLoading, setLoading] = useState(false)
  const [isLoadingImg, setLoadingImg] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

 // console.log("props on tune up", props);

  const location = useLocation();

 // console.log("location", location);
  let addresslength = location?.state?.UserData?.results?.address?.address.length ? location?.state?.UserData?.results?.address?.address.length : null;
  let cardlength = location?.state?.UserData?.results?.card?.id ? location?.state?.UserData?.results?.card?.id : null;
  let fname = location?.state?.UserData?.results?.first_name ? location?.state?.UserData?.results?.first_name : null;
  let lname = location?.state?.UserData?.results?.last_name ? location?.state?.UserData?.results?.last_name : null;

  let mobile = location?.state?.UserData?.results?.mobile ? location?.state?.UserData?.results?.mobile : null;

  let zipcode = location?.state?.UserData?.results?.address?.zipcode ? location?.state?.UserData?.results?.address?.zipcode : null;


  let vehicle_gear = location?.state?.UserData?.results?.vehicle_gear?.display_name ? location?.state?.UserData?.results?.vehicle_gear?.display_name : null;

  let vehicle_make = location?.state?.UserData?.results?.vehicle_make?.display_name ? location?.state?.UserData?.results?.vehicle_make?.display_name : null;

  let vehicle_type = location?.state?.UserData?.results?.vehicle_type?.display_name ? location?.state?.UserData?.results?.vehicle_type?.display_name : null;

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [selectedPanel, setSelectedPanel] = useState(0);

  const [replaceParts, setReplaceParts] = useState('');
  const [cost, setCost] = useState('');
  const [duration, setDuration] = useState('');
  const [bookingModalIsOpen, setBookingModalISOpen] = useState(false);
  const [modalHasBeenOpened, setModalHasBeenOpened] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [userAddress, setUserAddress] = useState('');
  const [imgValue, setImgValue] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [ImageError, setImageError] = useState('');
  const filesRef = useRef(null);
  const [cardAddPopup, setCardAddPopup] = React.useState(true);

  const validationSchema = Yup.object().shape({
    replace_parts: Yup.string().max(256, 'Replace parts should not exceed 250 characters')
      .test('no-leading-space', 'Field cannot start with a whitespace.', value => {
        if (value && /^\s/.test(value)) {
          return false;
        }
        return true;
      }),

    plans_cost: Yup.string().max(256),
    plan_duration: Yup.string().max(256),
    plans_id: Yup.string().max(256),

    // plans: Yup.object()
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, setValue, handleSubmit, reset, formState: { errors } } = useForm(formOptions);

  // setUserAddress(location?.state?.userData?.results?.address?.address);
  // console.log("user address", userAddress);



  useEffect(() => {

    if (!modalHasBeenOpened) {
      setModalHasBeenOpened(true);
      localStorage.setItem('modalHasBeenOpened', true);
    }

  }, [addresslength]);

  useEffect(() => {
    const hasModalBeenOpened = localStorage.getItem('modalHasBeenOpened');
    // setImageError('');

    if (hasModalBeenOpened) {
      setModalHasBeenOpened(true);
    }
  }, []);

  const handleTabClick = (tabIndex) => {
    setSelectedTab(tabIndex);
  };

  // const [files, setFiles] = useState(null);
  // const [fileErrorMessagefiles, setFileErrorMessage] = useState('');

  // const onFilesChange = (files) => {
  //   setFiles(files);
  //   console.log(files)
  // };

  // const onFilesError = (error, file) => {
  //   setFileErrorMessage(error.message);
  //   console.log(file)
  //   console.log('error code ' + error.code + ': ' + error.message);
  //   // errorfileMessage = error.message
  // };

  // const filesRemoveAll = () => {
  //   filesRef.files.removeFiles()
  // }

  const ImageViewClick = (file) => {
    const index = files.findIndex((f) => f.preview === file.preview);
    setSelectedIndex(index);
   // console.log("Preview URL:", file.preview);
    setSelectedImage(file.preview);
    setLightboxOpen(true);
  }



  // DropZone fileupload
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': []
    },
    onDrop: acceptedFiles => {
      // setFiles([...files, acceptedFiles.map(file => Object.assign(file, {
      //   preview: URL.createObjectURL(file)
      // }))].flat(2));
      setFiles([...files, acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      }))].flat(2));
    }
  });
//  console.log("files", files);
  //const fileFlat = files.flat(2)

  const ImageClick = (file) => {
  //  console.log("name", file);
    let filterImage = files.filter((val, i) => {
      if (val.preview != file.preview) {
        return val
      }
    })
    setFiles(filterImage)
  }

  const goToNextImage = () => {
    if (selectedIndex < files.length - 1) {
      setSelectedIndex(selectedIndex + 1);
      setSelectedImage(files[selectedIndex + 1].preview);
    }
  };

  const goToPrevImage = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
      setSelectedImage(files[selectedIndex - 1].preview);
    }
  };



  const thumbs = files?.map(file => (
    <div style={thumb} key={file.name} >
      <div style={thumbInner}>
        <div style={{ position: 'relative', width: 150 }}>
          <img
            src={file.preview}
            style={img}
            onClick={() => ImageViewClick(file)}
          // Revoke data uri after image is loaded
          // onLoad={() => { URL.revokeObjectURL(file.preview) }}
          />

          <div style={{ position: 'absolute', top: -10, right: -27, color: '#FF5F07' }}>
            <Icon path={mdiCloseCircleOutline} size={1} onClick={() => ImageClick(file)} />
          </div>
        </div>
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);

  // console.log(addresslength);


  // const handleFileSubmit = async (e) => {
  //   e.preventDefault();

  // };

 // console.log("imgValue", imgValue);
  let imgdata = [];
  imgdata.push(imgValue);
 // console.log("imgdata", imgdata);
  const onSubmit = async (data) => {
    setLoadingImg(true);
    //console.log("data on plans1", data);
    // setImageError('');
    // if (files.length === 0) {
    //   setImageError("Please add a few bike pics to aid our mechanic");
    //   setLoadingImg(false);
    //   return; // Prevent form submission
    // }
    if (!addresslength || !mobile || !fname || !lname || !vehicle_type || !vehicle_make || !vehicle_gear || !zipcode) { // Removed card from the if condition
      setBookingModalISOpen(true);
    //  console.log("status", bookingModalIsOpen);
    }
    else {
       setBookingModalISOpen(false);
      // console.log("cost on submit", cost);
      // console.log("data on plans2", data);
      // data.replace_parts = replaceParts;
      // const datas = {
      //   replace_parts: data.replace_parts,
      //   duration: data.plan_duration,
      //   cost: data.plans_cost,
      //   planId: data.plan_id,
      //   service: service,
      //   service_id: data?.service_id
      // }
      // console.log("onsubmit", replaceParts)
      // setLoading(true)
      // if(files) {
      //   const formData = new FormData()
      //   Object.keys(files).forEach((key) => {
      //     const file = files[key]
      //     formData.append('image', new Blob([file], { type: file.type }), file.name || 'file')
      //   })
      //   dispatch({ type: IMAGEUPLOAD, payload: agent.Contactus.imageupload(formData) })
      // }
      //dispatch({ type: REPLACE_PARTS_DATA, payload: datas })
      // console.log(files)
      // if (files.length != 0) {
      //   let formData = new FormData()
      //   const fileObjects = acceptedFiles.map(file => {
      //     // console.log(file)
      //     formData.append('image_url', file, file.name)
      //   })
      //   dispatch({ type: IMAGEUPLOAD, payload: agent.Contactus.imageupload(formData) })
      // }
      // else {
      let imgValue;
      // setTimeout(() => {
      //   setImageError('');
      // }, [10000])

      let count = 0;
      if (files.length != 0) {
        // files.forEach((item)=>{
        let imagedata;
        var formData = new FormData();
        for (var i = 0; i < files.length; i++) {
          formData.append("images", files[i]);
        }

       // console.log("formData", formData);
        const accessToken = JSON.parse(localStorage.getItem("access_token"));
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `file/upload-multiple`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': `${accessToken}`,
            'x-request-time': new Date().toString(),
            'x-request-timezone': timeZone
          }
        }).then((res) => {
        //  console.log(res?.data?.results)
          imagedata = res?.data?.results;
          if (res?.data?.results) {
            data.replace_parts = replaceParts;
            const datas = {
              replace_parts: data.replace_parts,
              duration: data.plan_duration,
              cost: data.plans_cost,
              planId: data.plan_id,
              service: service,
              service_id: data?.service_id,
              image: res?.data?.results?.files?.map((item) => {
                return item?.location
              })
            }
            dispatch({ type: REPLACE_PARTS_DATA, payload: datas })
            return navigate("/booking-time",{state:files});
          }
          //setFiles([]);
          setLoadingImg(false);
          //return navigate("/booking-time");
        }).catch((err) => {
         // console.log(err)
      //    if (files.length > 5) {
      //     setImageError("Please give up to five images");
      // } else {
      //     setImageError("Failed to upload image. Please try again.");
      // }
          setLoadingImg(false);
          //setFiles([]);
        })
        //})

      }
      else {
        data.replace_parts = replaceParts;
        const datas = {
          replace_parts: data.replace_parts,
          duration: data.plan_duration,
          cost: data.plans_cost,
          planId: data.plan_id,
          service: service,
          service_id: data?.service_id,
          image: {}
        }
        dispatch({ type: REPLACE_PARTS_DATA, payload: datas })
        setLoadingImg(false);
        return navigate("/booking-time");
      }

      //return navigate("/booking-time");
      // }

    }
  }

  // const [files, setFiles] = useState([]);
  // const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
  //   accept: {
  //     'image_url/png': [],
  //     'image_url/jpeg': [],
  //     'image_url/jpg': [],
  //   },
  //   maxFiles: 3,
  //   maxSize: 5000000,
  //   // onError: onFileError => {
  //   //   console.log(onFileError)
  //   // },
  //   onDrop: acceptedFiles => {
  //     setFiles(acceptedFiles.map(file => Object.assign(file, {
  //       preview: URL.createObjectURL(file)
  //     })));
  //   }
  // });

  // const fileRejectionItems = fileRejections.map(({ file, errors }) => {
  //   //console.log(errors);
  //   // console.log("errors");

  //   if (errors[0].code === 'file-too-large') {
  //     return '1';
  //   } else if (errors[0].code === 'too-many-files') {
  //     return '2';
  //   } else if (errors[0].code === 'file-invalid-type') {
  //     return '3';
  //   }


  //   // return (
  //   //   <li key={file.path}>
  //   //     {errors.map((e) => {
  //   //       if(e.code === 'file-too-large') {
  //   //         return <span key={e.code}>File size is too large, please upload below 10Mb.</span>
  //   //       } else if(e.code === 'too-many-files') {
  //   //         return <span key={e.code}>Only three files are allowed.</span>
  //   //       } else if(e.code === 'file-invalid-type') {
  //   //         return <span key={e.code}>Please enter valid file format.</span>
  //   //       }
  //   //     })}

  //   //   </li>
  //   // ) 
  // });

  // let errorMsgItem = [];
  // errorMsgItem = fileRejectionItems;
  // if (errorMsgItem.length > 0) {
  //   if (errorMsgItem[0] == '1') {
  //     errorMsgItem = 'File size is too large, please upload below 5MB.';
  //   } else if (errorMsgItem[0] === '2') {
  //     errorMsgItem = 'Only three files are allowed';
  //   } else if (errorMsgItem[0] === '3') {
  //     errorMsgItem = 'Please enter valid file format.';
  //   }
  // }

  // useEffect(() => {

  //   if (location.state === null) {
  //     return navigate("/home");
  //   }

  //   dispatch({ type: IMAGEUPLOAD_UNLOAD })
  // }, []);

  const handleChangeResetForm = () => {
    //console.log("Sfsdfsdfsdf")
    reset();
  }
  // console.log('files',files);
  //   const thumbs = files.map(file => (
  //     <div style={thumb} key={file.name}>
  //       <div style={thumbInner}>
  //         <img
  //           src={file.preview}
  //           style={img}
  //           //alt=""
  //           // Revoke data uri after image is loaded
  //           onLoad={() => { URL.revokeObjectURL(file.preview) }}
  //         />
  //       </div>
  //     </div>
  //   ));

  const handlePlanSelect = (plans) => {
    // alert("hi");
    // let inputValue = event.target.value;
    // console.log("plans on activate", plans);
    // console.log("input value", inputValue);
    // setReplaceParts(inputValue);
    // setValue('replace_parts', inputValue);
    setValue('plans_cost', plans?.cost);
    setValue('plan_id', plans?._id);
    setValue('plan_duration', plans?.duration);    // Perform any other operations on inputValue or plans as needed
  };

  const handleReplaceParts = (event) => {
    // alert("hi");
    let inputValue = event.target.value;
    // console.log("input value", inputValue);
    setReplaceParts(inputValue);
    setValue('replace_parts', inputValue);
    // setValue('plans_cost', plans?.cost);
    // setValue('plan_id', plans?._id);
    // setValue('plan_duration', plans?.duration);    // Perform any other operations on inputValue or plans as needed
  };



  // console.log("Replce parts", replaceParts);

  // if (props.common.currentUser != null) {
  let plans_title = '';
  let plans_data = null;
  let plans_length = 0
  let service_id = '';
  let service = '';
  if (location.state) {
    //console.log(location)
    plans_data = location.state;
    // console.log("plans data", plans_data?.plans);
    // setValue('plans_cost', plans_data?.plans[0]?.cost);
    // setValue('plan_id', plans_data?.plans[0]?._id);
    // setValue('plan_duration', plans_data?.plans[0]?.duration);
    // console.log("plans data", plans_data);
    plans_length = (plans_data.plans).length;
    plans_title = plans_data.plans_title ? plans_data.plans_title : '';
    service = plans_data?.plans_title ? plans_data?.plans_title : '';
    service_id = plans_data?.service_id ? plans_data?.service_id : '';
  }
  if (props.imageupload.file_upload) {

    // setLoading(false)
    navigate("/booking-time")
  }

  // console.log("plans cost", planCost);

  // const handlePlanClick = (plans) => {
  //   alert("hi");
  //   console.log("plan data", plans);
  // }
  const handlePlanSelection = (plans) => {
    // console.log("splans", plans);
    setValue('plans_cost', plans?.cost);
    setValue('plan_id', plans?._id);
    setValue('plan_duration', plans?.duration);
  }

  const customStyles = {
    // content: {
    //   top: '20px',
    //   left: 0,
    //   right: 0,
    //   bottom: '20px',
    //   margin: '0 auto',
    //   background: '#fff',
    //   maxWidth: '600px',
    //   padding: '30px 15px 0',
    //   width: '100%'
    // }
    content: {
      top: '45%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '20px 15px',
      width: '90%'
    },
  };


  function bookingModalIsCloseModal() {
    setBookingModalISOpen(false);
    setLoadingImg(false);
  }


  const handleButtonClick = () => {
    navigate('/profile-information', { state: { fromServicePage: true, servicePagePath: window.location.pathname, From: 'servcie', item: location?.state } });

  };

  const tabListHeight = plans_data.plans.length > 0 ? '5rem' : '0';
  const tabListMarginBottom = plans_data.plans.length > 0 ? '13px' : '0';



  return (
    <>
      <div className='tuneup-bg'>
        <div className='main'>
          <Helmet>
            <title>RideDoc | Orders | {plans_title}</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <Link to="/home" className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </Link>
              </div>
              <div className='tuneup-header-text'>
                <p className="header-mnutxt tuneup-title">{plans_title}</p>
              </div>
            </header>
          </div>

          <div className='main-wrapper'>
            <div className="tune-up-main-wrp" >
              <Tabs forceRenderTabPanel={true}>
                {plans_data.plans.length >= 2 ?
                  <div className="tune-up-tab">
                    <TabList style={{ height: tabListHeight, marginBottom: tabListMarginBottom }}>
                      {plans_data.plans.map((plans, index) => (
                        <Tab
                          key={index}
                          className={`tabslist ${plans.name}`}
                          style={{ marginRight: index < plans_data.plans.length - 1 ? '0.3rem' : '0'}}
                        >
                          {plans.display_name}
                        </Tab>
                      ))}
                    </TabList>
                  </div>
                  :
                  <div className="tune-up-tab">
                    <TabList>
                      <Tab className="tune-up-signletab">Basic</Tab>
                    </TabList>
                  </div>
                }


                {/* {console.log("plans data", plans_data)} */}

                {(plans_data) &&
                  <>

                    {plans_data.plans?.map((plans, plansId) => (
                      <TabPanel key={plansId} onClick={() => handlePlanSelect(plans)} className={'tabsdata ' + plans.name}
                      // onClick={() => handlePlanSelection(plans)}               
                      >

                        {/* {ImageError && <span className='error'>{ImageError}</span>} */}

                        <div className="tune-amt-wrp" id={plans.name}>
                          <div className="tune-amt-cnt">
                            {/* <img src={costBg} />   */}
                            <p className="tune-name-price">
                              {/* <strong>{plans.description}:</strong>  */}
                              <span>{plans.currency}{plans.cost}
                              </span>
                            </p>
                            <p className="tune-duration">
                              {/* <strong>(duration:</strong> <span>{plans.duration}mins</span>) */}
                            </p>
                            <div className='tune-amt-desc'>
                              <span style={{ fontSize: "1.09rem" }}>{plans.display_name}</span>
                            </div>
                          </div>

                          <div className="tune-desc-wrp">
                            <div className='tune-service-title'>
                              <div className='service_desc'>
                                <h3>Service Description</h3>
                              </div>
                              <div className='tune-duration-details' style={{ display: "flex" }}>
                                <div className='duration-img'>
                                  <img src={durationIcon} />
                                </div>
                                <div className='duration-details'>
                                  <span>{plans.duration} Mins</span>
                                </div>
                              </div>
                            </div>
                            <div style={{ whiteSpace: 'pre-line', paddingLeft: "1rem", paddingRight: "1.5rem", paddingBottom: "0.1rem" }}>
                              {/* {plans.service_includes?.map((service_includes) => ( */}

                              <ul>
                                {plans.service_includes.map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                              {/* // ))} */}
                            </div>
                          </div>

                          <div className="tune-form-wrp">
                            <div className="form-group-wrp">
                              <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group tune-form-group">
                                  <h3 className='h4' style={{ paddingBottom: "0.7rem" }}>Questions and Notes</h3>
                                  <textarea className="form-control form-textarea"
                                    placeholder="1) When was your last tune up?&#10;2) How many Miles do you ride?&#10;3) How old is your bike?&#10;4) Need parts replacement?"
                                    style={{ borderColor: "none" }}
                                    {...register('replace_parts')} value={replaceParts} name="replace_parts" id="replace_parts" cols="30" rows="10"
                                    onInput={(event) => (handleReplaceParts(event))}
                                  />
                                  {/* <span style={{ paddingTop: 5 }}>1) When was your last tune up?</span><br></br>
                                  <span>2) How many Miles do you ride?</span><br></br>
                                  <span>3) How old is your bike?</span><br></br> */}
                                </div>

                                <input type="hidden" {...register('plans_cost')} name='plan_cost' id='plans_cost' />
                                <input type="hidden" {...register('plan_duration')} name='plan_duration' id='plan_duraion' />
                                <input type="hidden" {...register('plan_id')} name='plan_id' id='plan_id' />
                                <input type="hidden" {...register('service_id')} name='service_id' id='service_id' defaultValue={service_id} />
                                <input type="hidden" {...register('service')} name='service' id='service' />


                                {errors.replace_parts &&
                                  <div className="invalid-feedback">{errors.replace_parts?.message}</div>
                                }
                                <div className="form-group tune-form-group">
                                  <h3 className='h4' style={{ paddingBottom: "0.5rem" }}>Add Pictures (Optional)</h3>
                                  <div {...getRootProps({ className: 'dropzone files-dropzone' })}>
                                    <input type='file' {...getInputProps()} />
                                    <div className='inner-input'>
                                      {/* <Icon path={mdiCloudUploadOutline} size={'28px'} color="#4A4949" /> */}
                                      <span path={mdiCloudUploadOutline} className='file'>Choose Photos</span>
                                    </div>
                                  </div>
                                  <aside style={thumbsContainer}>
                                    {thumbs}
                                  </aside>
                                  <span style={{ paddingTop: 5 }}>Allowed file types: .png, .jpeg, .jpg</span>
                                </div>
                                {/* {errorMsgItem.length > 0 &&
                                  <div className="invalid-feedback">{errorMsgItem}</div>
                                } */}
                                {/* {fileErrorMessagefiles && 
                            <div className="invalid-feedback">{fileErrorMessagefiles}</div>
                          } */}
                                {isLoadingImg ? (
                                  <div className="loading-icon-add">
                                    <div className="loading-icon" > </div>
                                  </div>
                                ) : null}
                                <div className="form-group">
                                  <button className="btn btn-primary" type="submit">Continue</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </TabPanel>

                    ))}
                  </>
                }
              </Tabs>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <Modal
        isOpen={bookingModalIsOpen}
        onRequestClose={bookingModalIsCloseModal}
        //setLoadingImg(false);
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="bookingOrderTimeSlot"
      >
        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={bookingModalIsCloseModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage' style={{fontSize: "1.2rem"}}>Please update profile information before placing an order</p>
            </div>
          </div>
        </div>
        <div className="ok-button" style={{width: "4.3rem",  margin: "0 auto"}}>
          <button className="btn btn-primary btn-update-ok"
             // onClick={() => { navigate(`/profile-information`) }}
            onClick={handleButtonClick}
           >Ok</button>
        </div>
      </Modal>

      {lightboxOpen && (
        <Lightbox
          mainSrc={selectedImage}
          nextSrc={selectedIndex < files.length - 1 ? files[selectedIndex + 1].preview : null}
          prevSrc={selectedIndex > 0 ? files[selectedIndex - 1].preview : null}
          onCloseRequest={() => setLightboxOpen(false)}
          onMoveNextRequest={goToNextImage}
          onMovePrevRequest={goToPrevImage}
          toolbarButtons={[]}
          prevButtonTitle={'Previous'}
          nextButtonTitle={'Next'}
          prevButtonRenderer={({ onClick }) => (
            <button type="button" className="custom-button" onClick={onClick}>
              <AiOutlineArrowLeft />
            </button>
          )}
          nextButtonRenderer={({ onClick }) => (
            <button type="button" className="custom-button" onClick={onClick}>
              <AiOutlineArrowRight />
            </button>
          )}
        />
      )}





    </>
  );

}

export default connect(mapStateToProps)(TuneUp);

